import { createTheme } from '@material-ui/core';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    sidebarWidth: number;
    sidebarMobileHeight: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth: number;
    galleryViewBackgroundColor: string;
  }

  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    sidebarWidth?: number;
    sidebarMobileHeight?: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth?: number;
    galleryViewBackgroundColor: string;
  }
}

const defaultTheme = createTheme();

export default createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        'html, body, #root': {
          height: '100%',
        },
      },
    },
    MuiButton: {
      root: {
        // borderRadius: '4px',
        // textTransform: 'none',
        // color: 'rgb(40, 42, 43)',
        // fontSize: '0.9rem',
        // transition: defaultTheme.transitions.create(['background-color', 'box-shadow', 'border', 'color'], {
        //   duration: defaultTheme.transitions.duration.short,
        // }),
        borderRadius: 10,
        padding: '0 10px',
        fontSize: 16,
        // lineHeight: 24,
        border: 'none',
        boxShadow: '-8px -8px 8px #fff, 5px 5px 8px #cbd9f0',
        background: '#eff2f7',
        color: '#000',
        outline: 'none',
        height: 50,

        textTransform: 'none'

        // margin: '0 5px'
      },
      text: {
        // padding: '6px 14px',
        // fontFamily: 'MuseoSans-Regular',
        padding: '0 10px',
        fontSize: 14,
        // lineHeight: 24,
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      outlinedPrimary: {
        // border: '2px solid #027AC5',
        // '&:hover': {
        //   border: '2px solid rgb(1, 85, 137)',
        // },
      },
      containedPrimary: {
        // border: '2px solid #027AC5',
        '&:hover': {
          backgroundColor: '#40cc52'
        },
        color: '#fff'
      },
      outlinedSecondary: {
        // border: '2px solid #027AC5',
        '&:hover': {
          backgroundColor: '#ff5f25',
          color: '#fff'
        },
      },
      startIcon: {
        marginRight: '6px',
      },
    },
    MuiTypography: {
      body1: {
        color: 'rgb(40, 42, 43)',
        fontSize: '0.9rem',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '0.9rem',
      },
    },
    MuiSelect: {
      root: {
        padding: '0.85em',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px',
      },
    },
    MuiTextField: {
      root: {
        color: 'rgb(40, 42, 43)',
      },
    },
    MuiInputLabel: {
      root: {
        color: 'rgb(40, 42, 43)',
        fontSize: '1.1rem',
        marginBottom: '0.2em',
        fontWeight: 500,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: 'rgb(136, 140, 142)',
      },
    },
    MuiSwitch: {
      root: {
        width: 42,
        height: 18,
        padding: 0,
        display: 'flex',
        marginRight: '0.5em',
      },
      switchBase: {
        padding: 2,
        color: '#FFFFFF',
        '&$checked': {
          transform: 'translateX(18px)',
          top: '50%',
          marginTop: -24 / 2,
          '&$disabled': {
            '& + $track': {
              opacity: '0.5',
            },
          },
        },
      },
      colorSecondary: {
        '&$checked': {
          // Controls checked color for the thumb
          color: 'FFFFF',
        },
      },
      thumb: {
        width: 14,
        height: 14,
        boxShadow: 'none',
      },
      track: {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: '#E1E3EA',
        '$checked$checked + &': {
          opacity: 1,
          backgroundColor: '#14B053',
        },
      },
    },
  },
  typography: {
    fontFamily: 'Nunito Sans, sans-serif',
  },
  palette: {
    primary: {
      main: '#40cc52',
    },
    secondary: {
      main: '#ff5f25',
    },
  },
  brand: '#E22525',
  footerHeight: 72,
  mobileFooterHeight: 56,
  sidebarWidth: 300,
  sidebarMobileHeight: 90,
  sidebarMobilePadding: 8,
  participantBorderWidth: 2,
  mobileTopBarHeight: 52,
  rightDrawerWidth: 320,
  galleryViewBackgroundColor: '#f0f2f5',
});
